import React from 'react';

export function MobileControls() {
    return (
        <div id="mobileControls" className="mobile-controls">
            <button id="mobileLeft" className="mobile-btn mobile-btn-left">
                ←
            </button>
            <button id="mobileJump" className="mobile-btn mobile-btn-jump">
                
            </button>
            <button id="mobileRight" className="mobile-btn mobile-btn-right">
                →
            </button>
        </div>
    );
}
